import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { ProfileService } from 'core/services/profile.service';
import { Profile } from 'core/models';
import { DashboardService } from '@widgets/services/dashboard.service';

export const DashboardResolver: ResolveFn<any> = (
  route?: ActivatedRouteSnapshot,
  state?: RouterStateSnapshot,
  dashboardService: DashboardService = inject(DashboardService),
  profileService: ProfileService = inject(ProfileService)
): Observable<any> => {
  const loggedUser: Profile = profileService.getLoggedUser();

  const paramClientId = route.paramMap.get('clientId');

  const clientIds = paramClientId
    ? [paramClientId]
    : loggedUser.roleOptions.scope === 'client'
    ? loggedUser.clients.map((cli) => cli.clientId)
    : [];

  return dashboardService.getDashboardWidgets$(clientIds);
};
